import { ENV } from "../utils";

export class AlertNotifications {
  baseApi = ENV.BASE_API;

  // company/site: lo elegido en el selector de arriba (acota las alertas de evidencias)
  async getAlerts(accessToken, { company, site } = {}) {
    const params = new URLSearchParams();
    if (company && company !== "0") params.set("company", company);
    if (site && site !== "0") params.set("site", site);
    const qs = params.toString();
    const response = await fetch(`${this.baseApi}/alert-notifications${qs ? `?${qs}` : ""}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getSettings(accessToken) {
    const response = await fetch(`${this.baseApi}/alert-notification-settings`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async saveSettings(accessToken, data) {
    const response = await fetch(`${this.baseApi}/alert-notification-settings`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
